'use client';

import Image from 'next/image';
import { useTranslation } from '@/hooks/useTranslations';
import './ProductSection.scss';

export default function ProductSection() {
  const { t } = useTranslation();

  return (
    <section id="product" className="product-section" aria-labelledby="product-section-title">
      <div className="product-section__inner">
        <div className="product-section__content">
          <p className="product-section__label">{t('product.label')}</p>

          <h2 id="product-section-title" className="product-section__title">
            {t('product.title')}
          </h2>

          <p className="product-section__subtitle">{t('product.subtitle')}</p>

          <ul className="product-section__features">
            <li className="product-section__feature">
              <span className="product-section__feature-icon">
                <Image
                  src="/hiring-icon.svg"
                  alt={t('product.features.hiringPage.iconAlt')}
                  width={16}
                  height={16}
                />
              </span>
              <div className="product-section__feature-text">
                <p className="product-section__feature-title">
                  {t('product.features.hiringPage.title')}
                </p>
                <p className="product-section__feature-description">
                  {t('product.features.hiringPage.description')}
                </p>
              </div>
            </li>

            <li className="product-section__feature">
              <span className="product-section__feature-icon">
                <Image
                  src="/qr-icon.svg"
                  alt={t('product.features.qr.iconAlt')}
                  width={16}
                  height={16}
                />
              </span>
              <div className="product-section__feature-text">
                <p className="product-section__feature-title">
                  {t('product.features.qr.title')}
                </p>
                <p className="product-section__feature-description">
                  {t('product.features.qr.description')}
                </p>
              </div>
            </li>

            <li className="product-section__feature">
              <span className="product-section__feature-icon">
                <Image
                  src="/phone-icon.svg"
                  alt={t('product.features.phone.iconAlt')}
                  width={16}
                  height={16}
                />
              </span>
              <div className="product-section__feature-text">
                <p className="product-section__feature-title">
                  {t('product.features.phone.title')}
                </p>
                <p className="product-section__feature-description">
                  {t('product.features.phone.description')}
                </p>
              </div>
            </li>

            <li className="product-section__feature">
              <span className="product-section__feature-icon">
                <Image
                  src="/workflow-icon.svg"
                  alt={t('product.features.workflow.iconAlt')}
                  width={16}
                  height={16}
                />
              </span>
              <div className="product-section__feature-text">
                <p className="product-section__feature-title">
                  {t('product.features.workflow.title')}
                </p>
                <p className="product-section__feature-description">
                  {t('product.features.workflow.description')}
                </p>
              </div>
            </li>
          </ul>
        </div>

        <div className="product-section__media">

          <Image
            src="/product-img.png"
            alt={t('product.imageAlt')}
            width={756}
            height={487}
            className="product-section__image"
          />
        </div>
      </div>
    </section>
  );
}
